// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"c5f2861a","787":"22e3b59d"}[chunkId] + ".chunk.js";
};